var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89288 11.51L3.20688 13.1365C2.96238 13.2505 2.74238 13.0145 2.85638 12.7855L4.48238 10.0975L5.89288 11.51ZM10.6195 3.611L12.388 5.356L6.76796 10.9795C6.10996 10.3205 5.19846 9.4085 5.01196 9.222L10.6195 3.611ZM12.3881 1.8415C12.5821 1.647 12.8966 1.647 13.0911 1.8415L14.1446 2.8955C14.3386 3.09 14.3386 3.4045 14.1446 3.5985L13.0911 4.653L11.3596 2.87L12.3881 1.8415ZM4.0551 9.034L1.9051 13.3865C1.7246 13.877 2.1166 14.316 2.6066 14.0885L6.9561 11.937C7.1436 11.9005 7.3256 11.8275 7.4706 11.6825L15.1981 3.9495C15.5861 3.562 15.5861 2.932 15.1981 2.544L13.4421 0.786499C13.0536 0.398499 12.4251 0.398499 12.0371 0.786499L4.3096 8.519C4.1641 8.6645 4.0921 8.8465 4.0551 9.034ZM15 6V14C15 14.5495 14.457 15.006 13.9085 15.006H1.987C1.4385 15.006 0.9935 14.561 0.9935 14.0115V2.0825C0.9935 1.533 1.451 1 2 1H10V0H2C0.903 0 0 0.9845 0 2.0825V14.0115C0 15.11 0.8895 16 1.987 16H13.9085C15.006 16 16 15.098 16 14V6H15Z",
    fill: "#1F5492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTableIcon);
export default __webpack_public_path__ + "static/media/EditTableIcon.6a1eed84b1ed8dc55f1dddc38ade2871.svg";
export { ForwardRef as ReactComponent };